module.exports = __webpack_public_path__ + "static/media/gullspangvapen.5c038216.png";